import PropTypes from 'prop-types';
import React from 'react';
import { cymbioColors } from '../../../utils/colors';

const strokeColor = cymbioColors.analytics.textPrimary;

export function ReportsSalesIcon({ color = strokeColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_0_1909)">
        <path
          d="M7.49935 4.16675H5.83268C5.39065 4.16675 4.96673 4.34234 4.65417 4.6549C4.34161 4.96746 4.16602 5.39139 4.16602 5.83341V15.8334C4.16602 16.2754 4.34161 16.6994 4.65417 17.0119C4.96673 17.3245 5.39065 17.5001 5.83268 17.5001H14.166C14.608 17.5001 15.032 17.3245 15.3445 17.0119C15.6571 16.6994 15.8327 16.2754 15.8327 15.8334V5.83341C15.8327 5.39139 15.6571 4.96746 15.3445 4.6549C15.032 4.34234 14.608 4.16675 14.166 4.16675H12.4993"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 4.16667C7.5 3.72464 7.6756 3.30072 7.98816 2.98816C8.30072 2.67559 8.72464 2.5 9.16667 2.5H10.8333C11.2754 2.5 11.6993 2.67559 12.0118 2.98816C12.3244 3.30072 12.5 3.72464 12.5 4.16667C12.5 4.60869 12.3244 5.03262 12.0118 5.34518C11.6993 5.65774 11.2754 5.83333 10.8333 5.83333H9.16667C8.72464 5.83333 8.30072 5.65774 7.98816 5.34518C7.6756 5.03262 7.5 4.60869 7.5 4.16667Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.5 10H7.50833" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.834 10H12.5007" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.5 13.3334H7.50833" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.834 13.3333H12.5007" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_0_1909">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

ReportsSalesIcon.propTypes = {
  color: PropTypes.string,
};
